import React from "react";

import { AnyObject } from "../../interfaces/anyObject";
import getSlugPartsTitle from "../../utils/getSlugPartsTitle";
import SEO from "../seo/seo";

interface MetadataProps {
  readonly hero_image?: Queries.Maybe<Queries.kontent_item_modular_content_element_value>;
  readonly metadata__meta_description: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__meta_title: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__og_description: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__og_image: Queries.Maybe<Queries.kontent_item_asset_element_value>;
  readonly metadata__og_title: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__twitter_creator: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__twitter_description: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__twitter_image: Queries.Maybe<Queries.kontent_item_asset_element_value>;
  readonly metadata__twitter_site: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly metadata__twitter_title: Queries.Maybe<Queries.kontent_item_text_element_value>;
  readonly meta_robots__noindex?: Queries.Maybe<Queries.kontent_item_taxonomy_element_value>;
}

interface GatsbyHeadProps {
  data: {
    page: {
      id: Queries.Scalars["ID"];
      elements?: Queries.Maybe<MetadataProps>;
    };
  };
  isHiddenForRobots?: boolean;
  linkingData?: AnyObject[];
  title?: string;
  headerImage?: { url: string }[] | null;
  useFallbackLevel?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const GatsbyHead: React.FC<GatsbyHeadProps> = ({
  data: { page },
  isHiddenForRobots: isHiddenForRobotsProp = null,
  linkingData = undefined,
  title = null,
  headerImage = null,
  useFallbackLevel = false,
}) => {
  let defaultHeaderImage = headerImage;

  if (!defaultHeaderImage) {
    defaultHeaderImage = [];

    if ((page.elements?.hero_image?.value?.length ?? 0) > 0) {
      if (page.elements?.hero_image?.value?.[0]?.system?.type === "image"
        && ((page.elements.hero_image.value[0] as Queries.kontent_item_image)?.elements?.image?.value?.length ?? 0) > 0
      ) {
        defaultHeaderImage = (page.elements.hero_image.value[0] as Queries.kontent_item_image)?.elements?.image?.value;
      } else if (page.elements?.hero_image?.value?.[0]?.system?.type === "video"
        && ((page.elements?.hero_image?.value?.[0] as Queries.kontent_item_video)?.elements?.placeholder_image?.value?.length ?? 0) > 0) {
        defaultHeaderImage = (page.elements?.hero_image?.value?.[0] as Queries.kontent_item_video)?.elements?.placeholder_image?.value;
      }
    }
  }

  let isHiddenForRobots = false;

  if (isHiddenForRobotsProp !== null) {
    // Overwrite from code if set
    isHiddenForRobots = isHiddenForRobotsProp;
  } else if (page.elements?.meta_robots__noindex) {
    // if Kontent value available overwrite
    isHiddenForRobots = (page.elements?.meta_robots__noindex.value?.length ?? 0) > 0;
  }

  return (
    <SEO
      title={title || page.elements?.metadata__meta_title?.value || ""}
      description={page.elements?.metadata__meta_description?.value || ""}
      twitterTitle={page.elements?.metadata__twitter_title?.value || ""}
      twitterSite={page.elements?.metadata__twitter_site?.value || ""}
      twitterImage={(page.elements?.metadata__twitter_image?.value?.length ?? 0) > 0
        ? page.elements?.metadata__twitter_image?.value
        : defaultHeaderImage}
      twitterDescription={page.elements?.metadata__twitter_description?.value || ""}
      twitterCreator={page.elements?.metadata__twitter_creator?.value || ""}
      ogTitle={page.elements?.metadata__og_title?.value || ""}
      ogImage={(page.elements?.metadata__og_image?.value?.length ?? 0) > 0
        ? page.elements?.metadata__og_image?.value
        : defaultHeaderImage}
      ogDescription={page.elements?.metadata__og_title?.value || ""}
      isHiddenForRobots={isHiddenForRobots}
      linkingData={linkingData}
      tag={getSlugPartsTitle(page.id, useFallbackLevel)}
    />
  );
};
